module.exports = __webpack_public_path__ + "img/logo.45460f0d.png";